
import { useState } from "react";

export function useImageHandling() {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [imageAnalysisMode, setImageAnalysisMode] = useState(false);

  const handleImageChange = (file: File | null) => {
    console.log("Image changed:", file ? file.name : "null");
    setSelectedImage(file);
    if (file) {
      const url = URL.createObjectURL(file);
      setImageUrl(url);
      console.log("Image URL created:", url);
    } else {
      setImageUrl(null);
    }
  };

  const reset = () => {
    setSelectedImage(null);
    setImageUrl(null);
  };

  return {
    selectedImage,
    imageUrl,
    imageAnalysisMode,
    setImageUrl,
    setImageAnalysisMode,
    handleImageChange,
    reset
  };
}
